export const getRatingFilter = state => state.rating.filter
